import React, { Component } from "react";
import "./School.css";
import Button from "./Button/Button";
import ModalVideo from "../../General/ModalVideos/ModalVideos";
import { Collapse, Grid, Row, Col } from "react-bootstrap";
import { prefix } from "../../../scripts/helpers/constants";
import logos from "../SchoolLogos";
import images from "../SchoolImages";
import { Arrow, Play } from "../../General/Svgs/SVGs";

class School extends Component {
  state = {
    open: false,
    modal: false,
    video: null
  };

  collapseClicked = () => {
    this.setState({ open: !this.state.open });
  };

  videoClicked = url => {
    this.setState({ modal: true });
    this.setState({ video: url });
  };

  handleHide = () => {
    this.setState({ modal: false });
  };

  render() {
    return (
      <div className={prefix + "-c-school"}>
        <Grid className="no-padding school-main">
          <Row className="no-margin">
            <Col xs={4} md={3} className="no-padding school-icon">
              <a
                className={"school-arrow-icon " + this.props.image}
                onClick={this.collapseClicked}
              >
                <Arrow
                  reference={
                    "svg-icon school-arrow " +
                    (this.state.open
                      ? "school-arrow-open"
                      : "school-arrow-closed")
                  }
                />
              </a>
              <img src={logos[this.props.image]} alt={this.props.name} />
            </Col>
            <Col xs={8} md={9} className="no-padding school-text">
              <Row className="no-margin">
                <Col xs={12} md={6} className="no-padding school-text-name">
                  <p className="p1">{this.props.name}</p>
                </Col>
                <Col xs={5} md={4} className="no-padding school-text-state">
                  <p className="p2">{this.props.city}</p>
                </Col>
                <Col xs={7} md={2} className="no-padding school-text-type">
                  <p className="p2">{this.props.gender}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
        <Grid className="no-padding school-main">
          <Row className="no-margin school-main">
            <Col xs={12} md={12} className="no-padding">
              <Collapse in={this.state.open} className="school-main-data">
                <Grid className="no-padding">
                  <Row className="no-margin school-main">
                    <Col xs={12} md={6} sm={6} className="no-padding">
                      {this.props.description2 ? (
                        <p className="p3 school-text bold">
                          {this.props.description2}
                        </p>
                      ) : null}
                      <p className="p3 school-text">
                        {this.props.description1}
                      </p>
                      <Row className="no-margin school-button-contact-sub">
                        <Col
                          md={12}
                          xsHidden={true}
                          sm={12}
                          className="no-padding school-button"
                        >
                          <Button reference={this.props.site}>
                            <p className="p3">Visit site</p>
                          </Button>
                          <Button reference={this.props.admissionLink}>
                            <p className="p3 btn-admissions">Admissions</p>
                          </Button>
                        </Col>
                        <Col
                          md={12}
                          xsHidden={true}
                          sm={12}
                          className="no-padding"
                        >
                          <div className="school-contact">
                            <p className="p3">{this.props.address1}</p>
                            <p className="p3">{this.props.address2}</p>
                            <p className="p3">
                              <a href={"tel:" + this.props.phoneLink}>
                                {this.props.phone}
                              </a>
                            </p>
                            {this.props.secondPhone ? (
                              <p className="p3">
                                <a href={"tel:" + this.props.secondPhoneLink}>
                                  {this.props.secondPhone}
                                </a>
                              </p>
                            ) : null}
                            {this.props.maps ? (
                              <a target="_blank" href={this.props.maps}>
                                <p className="p3">Google Maps</p>
                              </a>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12} md={6} sm={6} className="no-padding">
                      <div className="content-wrapper">
                        <a
                          onClick={
                            this.props.video
                              ? () => this.videoClicked(this.props.video)
                              : null
                          }
                          className={
                            this.props.video
                              ? "video-" +
                                this.props.name
                                  .replace(/\s+/g, "-")
                                  .replace(/[.’\s]/g, "")
                                  .toLowerCase() +
                                " school-asset-placeholder video"
                              : "school-asset-placeholder image"
                          }
                        >
                          <img
                            className="school-video"
                            src={images[this.props.image]}
                            alt={this.props.name + " image"}
                          />
                          {this.props.video ? (
                            <Play reference="svg-icon school-video-play-icon" />
                          ) : null}
                        </a>
                        <div className="school-video-words mobile-words">
                          <div className="school-words">
                            {this.props.attributes.map((wordkey) => {
                              return (
                                <p key={wordkey}>
                                  <span className="p4 school-words-span">
                                    {wordkey}
                                  </span>
                                </p>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="no-margin">
                    <Col
                      xs={12}
                      smHidden={true}
                      mdHidden={true}
                      lgHidden={true}
                      className="no-padding school-button-contact-mobile school-button-contact-sub"
                    >
                      <Row className="no-margin">
                        <Col xs={7} className="no-padding school-button">
                          <Button reference={this.props.site}>
                            <p className="p3">Visit site</p>
                          </Button>
                          <Button reference={this.props.admissionLink}>
                            <p className="p3 btn-admissions">Admissions</p>
                          </Button>
                        </Col>
                        <Col xs={5} className="no-padding">
                          <div className="school-contact">
                            <p className="p3">{this.props.address1}</p>
                            <p className="p3">{this.props.address2}</p>
                            <p className="p3">
                              <a href={"tel:" + this.props.phoneLink}>
                                {this.props.phone}
                              </a>
                            </p>
                            {this.props.secondPhone ? (
                              <p className="p3">
                                <a href={"tel:" + this.props.secondPhoneLink}>
                                  {this.props.secondPhone}
                                </a>
                              </p>
                            ) : null}
                            <a target="_blank" href={this.props.maps}>
                              <p className="p3">Google Maps</p>
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      xs={12}
                      smHidden={true}
                      mdHidden={true}
                      lgHidden={true}
                      className="no-padding school-words-mobile"
                    >
                      <div className="school-video-words">
                        <div className="school-words">
                          {this.props.attributes.map((wordkey) => {
                            return (
                              <span
                                key={wordkey}
                                className="p4 school-words-span"
                              >
                                {wordkey}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </Collapse>
            </Col>
          </Row>
        </Grid>
        <ModalVideo
          show={this.state.modal}
          modalClosed={this.handleHide}
          videoCode={this.state.video}
        />
      </div>
    );
  }
}

export default School;



// WEBPACK FOOTER //
// ./src/components/SchoolBand/School/School.js